import React, { FC } from "react";
import { makeStyles } from "@material-ui/core";
import { Colors } from "../../styles";
import MultilineHouseIcon from "../../assets/images/multiline_house_icon.svg";
import MultilineCheckIcon from "../../assets/images/multiline_check_icon.svg";

const useStyles = makeStyles(() => ({
    container: {
        padding: 24,
        borderRadius: 8,
        marginTop: 8,
        marginLeft: 20,
        marginRight: 20,
        fontSize: 18,
        fontWeight: 200,
        fontStretch: "normal",
        fontStyle: "normal",
        fontFamily: "innogyWEB",
        lineHeight: "28px",
        letterSpacing: "normal",
        color: Colors.white,

        backgroundColor: Colors.teaserBackground,
    },
    multilineHouseIcon: {
        width: 72,
        height: 94,
        marginLeft: 32,
        marginBottom: 32,
        float: "right",
    },
    multilineCheckIcon: {
        width: 20,
        height: 20,
        marginRight: 16,
        marginTop: 4,
        alignItems: "flex-start",
    },
    title: {
        fontSize: 25,
        fontWeight: 500,
        lineHeight: "32px",
        marginBottom: 8,
    },
    itemRow: {
        display: "flex",
        flexDirection: "row",
        flex: 1,
    },
    itemText: {
        flex: 1,
        alignItems: "flex-start",
        fontSize: 20,
        fontWeight: 300,
        lineHeight: "1.4",
    },
}));

type Props = {};

export const MultilineConnectionTeaser: FC<Props> = () => {
    const classes = useStyles();

    return (
        <div className={classes.container}>
            <img alt="" className={classes.multilineHouseIcon} src={MultilineHouseIcon} />
            <div className={classes.title}>Hinweis</div>
            <div className={classes.itemText}>
                Ein Mehrspartenanschluss bündelt alle Versorgungsleitungen für Wasser, Strom, Erdgas
                und Telekommunikation und führt sie bis in Ihr Haus.
            </div>
            <br />
            <div className={classes.title}>Vorteile Mehrsparten-Hauseinführung</div>
            <div>
                <div className={classes.itemRow}>
                    <img alt="" className={classes.multilineCheckIcon} src={MultilineCheckIcon} />
                    <div className={classes.itemText}>
                        100% gas- und wasserdichtes Produkt mit 25 Jahre Herstellergarantie
                    </div>
                </div>
                <div className={classes.itemRow}>
                    <img alt="" className={classes.multilineCheckIcon} src={MultilineCheckIcon} />
                    <div className={classes.itemText}>
                        alle Versorgungsleitungen in nur einer Wanddurchführung
                    </div>
                </div>
                <div className={classes.itemRow}>
                    <img alt="" className={classes.multilineCheckIcon} src={MultilineCheckIcon} />
                    <div className={classes.itemText}>
                        Optimale Raumnutzung im Hausanschlussraum, da alle Hausanschlüsse sauber und
                        platzsparend an einer Wand installiert sind
                    </div>
                </div>
            </div>
        </div>
    );
};
